import { Component } from '@angular/core';
import { DirectivesModule, PipesModule, SharedModule } from '../shared';

/**
 * Public 404 page shown for unknown routes.
 */
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  imports: [SharedModule, DirectivesModule, PipesModule],
  host: {
    class: 'd-flex min-vh-100 flex-column',
  },
})
export class ErrorComponent {}
